// client/src/routes/_auth/preluare-proprietate.$token.tsx — SCR-PROP-005 „Preluare
// proprietate" · D-1902.
//
// The path is the server's, not this file's: `PropertyHandoverMapping` composes
// `{origin}/preluare-proprietate/{token}` and hands it back as `acceptUrl`, and every offer ever
// issued points at exactly that. It goes in 04 §8.1 beside `/invite/$token`, which is the same
// kind of page for the same kind of credential.
//
// Under the pathless `_auth` layout, which gives the centred card, the full logo and the footer
// — the right frame for a page opened from a link somebody pasted into WhatsApp.
//
// Nobody is redirected AWAY from here in either direction. An anonymous visitor is the ordinary
// case, because the person receiving a property is usually not inside yet; a signed-in one is
// the other ordinary case. The screen itself decides what to do with the token it holds.
//
// It still has to BOOTSTRAP, which is a different thing and is what every route does in
// `beforeLoad`. Opening a pasted link is a hard navigation, so nothing has presented the refresh
// cookie and the store is still `unknown` — the branch that renders „Se verifică oferta…".
// Without this the page waits on a bootstrap nobody started, forever. `ensureSession()` redirects
// nobody; it resolves the store to `anonymous` or `authenticated` once.

import { createFileRoute } from '@tanstack/react-router';

import { AcceptPropertyHandover } from '@/features/properties/AcceptPropertyHandover';
import { ensureSession } from '@/session';

export const Route = createFileRoute('/_auth/preluare-proprietate/$token')({
  beforeLoad: async () => {
    await ensureSession();
  },
  component: AcceptPropertyHandoverScreen,
});

function AcceptPropertyHandoverScreen() {
  const { token } = Route.useParams();
  return <AcceptPropertyHandover token={token} />;
}
